import { useEffect, useRef, useState } from "react";
import "./HotelQuotePrint.scss";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useParams } from "react-router-dom";
import { getHotelQuotationByID } from "../services/quotation.services";
import moment from "moment";
import IconComponent from "../../../components/common/IconComponent";
import { IoIosMail } from "react-icons/io";
import { MdCall, MdOutgoingMail, MdPrint } from "react-icons/md";
import { TbWorldWww } from "react-icons/tb";
import { FaLocationDot } from "react-icons/fa6";
import { formatIndianNumber } from "../../../_helper/helper";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { LoadingPanel } from "../../../components/layout/Loading";
import { getLocalAccessToken } from "../../../app/getTokens";
import { axiosApiInstance } from "../../../app/axios";
import { FaFilePdf } from "react-icons/fa";

const HotelQuotePrint = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const HotelQuot_GUID = params?.HotelQuot_GUID;
  const HotelQuotationDetail = useAppSelector(
    (state) => state.quotation.HotelQuotationDetail
  );

  const [emailLoading, setEmailLoading] = useState(false);
  const [PDFLoading, setPDFLoading] = useState(false);

  useEffect(() => {
    if (HotelQuot_GUID) {
      dispatch(getHotelQuotationByID({ HotelQuot_GUID: HotelQuot_GUID }));
    }
  }, [HotelQuot_GUID]);

  // const downloadPDF = () => {
  //   // Create download modal
  //   const modal = document.createElement("div");
  //   modal.style.cssText = `
  //     position: fixed;
  //     top: 0;
  //     left: 0;
  //     width: 100%;
  //     height: 100%;
  //     background: rgba(0,0,0,0.8);
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     z-index: 10000;
  //   `;

  //   const modalContent = document.createElement("div");
  //   modalContent.style.cssText = `
  //     background: white;
  //     padding: 30px;
  //     border-radius: 15px;
  //     text-align: center;
  //     max-width: 400px;
  //     box-shadow: 0 25px 50px rgba(0,0,0,0.3);
  //   `;

  //   modalContent.innerHTML = `
  //     <h3 style="color: #3498db; margin-bottom: 20px;">📄 PDF Download</h3>
  //     <p style="margin-bottom: 20px; color: #2c3e50;">PDF download functionality would be implemented with a backend service. For now, please use the print option to save as PDF.</p>
  //     <div style="display: flex; gap: 10px; justify-content: center;">
  //       <button onclick="window.print(); this.closest('div[style*=\"position: fixed\"]').remove()" style="background: #3498db; color: white; border: none; padding: 12px 20px; border-radius: 8px; cursor: pointer; font-weight: 600;">Print Instead</button>
  //       <button onclick="this.closest('div[style*=\"position: fixed\"]').remove()" style="background: #95a5a6; color: white; border: none; padding: 12px 20px; border-radius: 8px; cursor: pointer; font-weight: 600;">Close</button>
  //     </div>
  //   `;

  //   modal.appendChild(modalContent);
  //   document.body.appendChild(modal);
  // };

  const getStatusClass = (status: any) => {
    switch (status?.toLowerCase()) {
      case "draft":
        return "status-draft";
      case "pending":
        return "status-pending";
      case "confirmed":
        return "status-confirmed";
      default:
        return "status-draft";
    }
  };

  const handleSendEmail = async (HotelQuot_GUID: string) => {
    try {
      setEmailLoading(true);
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelQuotation/DynamicGetHotelQuotationPDF`,
        { HotelQuot_GUID: HotelQuot_GUID }
      );
      if (response.status === 200) {
        SuccessToast("Email Sent Successfully!");
      } else {
        ErrorToast("Failed to Send Email!");
      }
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to sending Quotation! - Please try again later");
    } finally {
      setEmailLoading(false);
    }
  };

  const handleQuotationDownload = async (HotelQuot_GUID: string) => {
    const token = getLocalAccessToken();
    try {
      setPDFLoading(true);

      const response = await fetch(
        `${API_URL}/HotelQuotation/DynamicDoWnloadGetHotelQuotationPDF`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            HotelQuot_GUID: HotelQuot_GUID,
          }),
        }
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Hotel Processing Quotation.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Quotation! - Please try again later");
    } finally {
      setPDFLoading(false);
    }
  };

  return (
    <>
      {(emailLoading || PDFLoading) && <LoadingPanel gridRef={gridRef} />}
      <div className="hotel-quote-print-container">
        {/* <div className="header">
        <div className="header-content">
          <div className="company-logo">
            🏨{" "}
            {HotelQuotationDetail?.CompanyInfo &&
            HotelQuotationDetail?.CompanyInfo?.CompanyName
              ? HotelQuotationDetail?.CompanyInfo?.CompanyName
              : "AICRM Travel"}
          </div>
          <div className="company-tagline">Your Trusted Travel Partner</div>
          <div className="quote-title">Hotel Booking Quote</div>
        </div>
      </div> */}
        <div className="header">
          <div className="company-info">
            <div className="logo-section">
              {HotelQuotationDetail?.CompanyInfo &&
                HotelQuotationDetail?.CompanyInfo?.CompanyLogo && (
                  <img
                    src={
                      HotelQuotationDetail?.CompanyInfo &&
                      HotelQuotationDetail?.CompanyInfo?.CompanyLogo
                        ? HotelQuotationDetail?.CompanyInfo?.CompanyLogo
                        : ""
                    }
                    alt="Company Logo"
                    className="company-logo"
                  />
                )}
              <h1>
                {HotelQuotationDetail?.CompanyInfo &&
                HotelQuotationDetail?.CompanyInfo?.CompanyName
                  ? HotelQuotationDetail?.CompanyInfo?.CompanyName
                  : "AICRM Travel"}
              </h1>
              {/* <p>Your Trusted Hotel Booking Partner</p> */}
            </div>
            <div className="contact-info">
              {HotelQuotationDetail?.CompanyInfo?.EmailID && (
                <div>
                  <IconComponent icon={IoIosMail} />{" "}
                  {HotelQuotationDetail?.CompanyInfo?.EmailID}
                </div>
              )}
              {HotelQuotationDetail?.CompanyInfo?.MobileNo && (
                <div>
                  <IconComponent icon={MdCall} style={{ color: "red" }} />{" "}
                  {HotelQuotationDetail?.CompanyInfo?.MobileNo}
                </div>
              )}
              <div>
                <IconComponent icon={TbWorldWww} style={{ color: "#20c4f3" }} />{" "}
                www.aicrmtravel.com
              </div>
              {HotelQuotationDetail?.CompanyInfo?.Address && (
                <div>
                  <IconComponent
                    icon={FaLocationDot}
                    style={{ color: "red" }}
                  />{" "}
                  {HotelQuotationDetail?.CompanyInfo?.Address}
                </div>
              )}
              {HotelQuotationDetail?.CompanyInfo?.GSTNo && (
                <div>GSTIN: {HotelQuotationDetail?.CompanyInfo?.GSTNo}</div>
              )}
            </div>
          </div>
          <div className="quote-title">Hotel Booking Quote</div>
        </div>

        <div className="quote-content">
          <div className="quote-header">
            <div className="quote-info">
              <div className="info-title">Quote Information</div>
              <div className="info-item">
                <span className="info-label">Quote ID:</span>
                <span className="info-value">
                  {HotelQuotationDetail?.QuotationNo}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Date:</span>
                <span className="info-value">
                  {" "}
                  {HotelQuotationDetail?.CreatedOn
                    ? moment(HotelQuotationDetail?.CreatedOn).format(
                        "DD/MM/YYYY"
                      )
                    : ""}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Status:</span>
                <span
                  className={`status-badge ${getStatusClass(
                    HotelQuotationDetail.BookingStatus
                  )}`}
                >
                  {HotelQuotationDetail.BookingStatus}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Valid Until:</span>
                <span className="info-value">
                  {HotelQuotationDetail?.ExpiryDate
                    ? moment(HotelQuotationDetail?.ExpiryDate).format(
                        "DD/MM/YYYY"
                      )
                    : ""}
                </span>
              </div>
            </div>

            <div className="quote-info">
              <div className="info-title">Client Information</div>
              <div className="info-item">
                <span className="info-label">Name:</span>
                <span className="info-value">
                  {HotelQuotationDetail?.Initial}{" "}
                  {HotelQuotationDetail?.FirstName}{" "}
                  {HotelQuotationDetail?.LastName}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Email:</span>
                <span className="info-value">
                  {HotelQuotationDetail?.EmailID}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Phone:</span>
                <span className="info-value">
                  {HotelQuotationDetail?.MobileNo}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Nationality:</span>
                <span className="info-value">
                  {HotelQuotationDetail?.Nationality}
                </span>
              </div>
            </div>
          </div>

          <div className="flight-print-section">
            <div className="section-title">
              <div className="section-icon">🏨</div>
              Hotel Details
            </div>
            <div className="details-grid">
              <div className="detail-card">
                <div className="info-item">
                  <span className="info-label">Hotel Name:</span>
                  <span className="info-value">
                    {HotelQuotationDetail?.HotelName}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Location:</span>
                  <span className="info-value">
                    {HotelQuotationDetail?.CityName}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Star Rating:</span>
                  <span className="info-value">
                    {HotelQuotationDetail?.Rating} Star
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Room Type:</span>
                  <span className="info-value">
                    {HotelQuotationDetail?.RoomCategoryName}
                  </span>
                </div>
              </div>
              <div className="detail-card">
                <div className="info-title">Address</div>
                <p
                  style={{
                    color: "#2c3e50",
                    lineHeight: "1.5",
                    marginTop: "10px",
                  }}
                >
                  {HotelQuotationDetail?.HotelAddress}
                </p>
              </div>
            </div>
          </div>

          <div className="booking-summary">
            <div
              className="section-title"
              style={{ borderBottom: "none", marginBottom: "20px" }}
            >
              <div className="section-icon">📅</div>
              Booking Summary
            </div>
            <div className="summary-grid">
              <div className="summary-item">
                <div className="summary-number">
                  {HotelQuotationDetail?.NoOfNights}
                </div>
                <div className="summary-label">Nights</div>
              </div>
              <div className="summary-item">
                <div className="summary-number">
                  {HotelQuotationDetail?.TotalRoom}
                </div>
                <div className="summary-label">Rooms</div>
              </div>
              <div className="summary-item">
                <div className="summary-number">
                  {HotelQuotationDetail?.TotalAdult || 0} +{" "}
                  {HotelQuotationDetail?.TotalChild || 0}
                </div>
                <div className="summary-label">Adults + Children</div>
              </div>
            </div>
            <div className="details-grid">
              <div className="detail-card">
                <div className="info-item">
                  <span className="info-label">Check-in:</span>
                  <span className="info-value">
                    {HotelQuotationDetail?.CheckInDate
                      ? moment(HotelQuotationDetail?.CheckInDate).format(
                          "DD/MM/YYYY"
                        )
                      : ""}
                    {HotelQuotationDetail?.CheckInDate &&
                      HotelQuotationDetail?.CheckInTime &&
                      ", "}
                    {HotelQuotationDetail?.CheckInTime
                      ? moment(HotelQuotationDetail?.CheckInTime).format(
                          "HH:mm"
                        )
                      : ""}
                  </span>
                </div>
                <div className="info-item">
                  <span className="info-label">Check-out:</span>
                  <span className="info-value">
                    {HotelQuotationDetail?.CheckOutDate
                      ? moment(HotelQuotationDetail?.CheckOutDate).format(
                          "DD/MM/YYYY"
                        )
                      : ""}
                    {HotelQuotationDetail?.CheckOutDate &&
                      HotelQuotationDetail?.CheckOutTime &&
                      ", "}
                    {HotelQuotationDetail?.CheckOutTime
                      ? moment(HotelQuotationDetail?.CheckOutTime).format(
                          "HH:mm"
                        )
                      : ""}
                  </span>
                </div>
              </div>
              <div className="detail-card">
                <div className="info-item">
                  <span className="info-label">Meal Plan:</span>
                  <span className="info-value">
                    {HotelQuotationDetail?.MealType}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="flight-print-section">
            <div className="section-title">
              <div className="section-icon">💰</div>
              Pricing Breakdown
            </div>
            <div className="pricing-table">
              <div className="pricing-header">
                <h3>Cost Details (INR)</h3>
              </div>
              <div className="pricing-body">
                {/* <div className="pricing-row">
                <span className="pricing-label">Room Rate (Per Night)</span>
                <span className="pricing-value">
                  ₹ {HotelQuotationDetail?.RoomRatePerNight || 0}
                </span>
              </div>
              <div className="pricing-row">
                <span className="pricing-label">
                  Extra Adult Rate (Per Night)
                </span>
                <span className="pricing-value">
                  ₹ {HotelQuotationDetail?.ExtraAdultRatePerNight || 0}
                </span>
              </div> */}
                <div className="pricing-row">
                  <span className="pricing-label">Total Room Cost</span>
                  <span className="pricing-value">
                    ₹{" "}
                    {formatIndianNumber(
                      +(HotelQuotationDetail?.TotalRoomCost || 0) +
                        +(HotelQuotationDetail?.ServiceCharges || 0)
                    )}
                  </span>
                </div>
                {/* <div className="pricing-row">
                <span className="pricing-label">Taxes & Fees</span>
                <span className="pricing-value">
                  ₹{" "}
                  {formatIndianNumber(HotelQuotationDetail?.TaxesAndFees || 0)}
                </span>
              </div> */}
                {/* <div className="pricing-row">
                <span className="pricing-label">Service Charges</span>
                <span className="pricing-value">
                  ₹{" "}
                  {formatIndianNumber(
                    HotelQuotationDetail?.ServiceCharges || 0
                  )}
                </span>
              </div> */}
                {/* <div className="pricing-row">
                <span className="pricing-label">Markup</span>
                <span className="pricing-value">
                  ₹ {HotelQuotationDetail?.MarkupPercentage || 0}
                </span>
              </div> */}
                <div className="pricing-row">
                  <span className="pricing-label">
                    GST{" "}
                    {HotelQuotationDetail?.GSTAmount &&
                    HotelQuotationDetail?.GSTAmount > 0 &&
                    HotelQuotationDetail?.GSTPer
                      ? `(${HotelQuotationDetail?.GSTPer}%)`
                      : ""}
                  </span>
                  <span className="pricing-value">
                    ₹ {formatIndianNumber(HotelQuotationDetail?.GSTAmount || 0)}
                  </span>
                </div>
                <div className="pricing-row total-row">
                  <span className="pricing-label">Total Amount</span>
                  <span className="pricing-value">
                    ₹{" "}
                    {formatIndianNumber(HotelQuotationDetail?.TotalAmount || 0)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {HotelQuotationDetail.Remarks && (
            <div className="special-requests">
              <div
                className="section-title"
                style={{ borderBottom: "none", marginBottom: "15px" }}
              >
                <div className="section-icon">📝</div>
                Special Requests
              </div>
              <p
                style={{ color: "#2c3e50", lineHeight: "1.6" }}
                dangerouslySetInnerHTML={{
                  __html: HotelQuotationDetail.Remarks,
                }}
              />
            </div>
          )}
        </div>

        {HotelQuotationDetail?.TermsAndCondition && (
          <div className="terms-conditions-container">
            <div>
              <strong>Terms & Condition</strong>
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: HotelQuotationDetail?.TermsAndCondition,
              }}
            />
          </div>
        )}

        <div className="action-buttons printbuttons">
          <button className="btn btn-primary" onClick={() => window.print()}>
            <IconComponent icon={MdPrint} className="fs-5" /> Print Quote
          </button>
          <button
            className="btn btn-success"
            onClick={() =>
              handleSendEmail(
                HotelQuotationDetail?.HotelQuot_GUID
                  ? HotelQuotationDetail?.HotelQuot_GUID
                  : ""
              )
            }
          >
            <IconComponent icon={MdOutgoingMail} className="fs-5" /> Send Email
          </button>
          <button
            className="btn btn-secondary"
            onClick={() =>
              handleQuotationDownload(
                HotelQuotationDetail?.HotelQuot_GUID
                  ? HotelQuotationDetail?.HotelQuot_GUID
                  : ""
              )
            }
          >
            <IconComponent icon={FaFilePdf} className="fs-6" /> Download PDF
          </button>
        </div>

        <div className="footer">
          <p>
            Thank you for choosing{" "}
            {HotelQuotationDetail?.CompanyInfo &&
            HotelQuotationDetail?.CompanyInfo?.CompanyName
              ? HotelQuotationDetail?.CompanyInfo?.CompanyName
              : "AICRM Travel"}{" "}
            for your hotel booking needs!
          </p>
          <p style={{ marginTop: "10px", fontSize: "14px", opacity: 0.9 }}>
            Quote generated on:{" "}
            {moment(HotelQuotationDetail?.CreatedOn).format("DD/MM/YYYY")} |
            Valid until:{" "}
            {moment(HotelQuotationDetail?.ExpiryDate).format("DD/MM/YYYY")}
          </p>
        </div>
      </div>
    </>
  );
};

export default HotelQuotePrint;
